import React, { useRef, useState } from "react";
import Webcam from "react-webcam";

const videoConstraints = {
  width: "284px",
  height:"10%",
  facingMode: "user",
};

const Camera = (props) => {
  const webcamRef = useRef(null);
  const [url, setUrl] = useState("");

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    setUrl(imageSrc);
    props.handleCapture(imageSrc);
    props.handleCloseSefliePopup()
  }, [webcamRef]);

  const onUserMedia = (e) => {
    // console.log(e);
  };

  return (
    <>
      {url ? (
        <div>
          <img src={url} alt="Screenshot" />
        </div>
      ) : (
        <Webcam
        style={{width:"280px"}}
          ref={webcamRef}
          audio={false}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          onUserMedia={onUserMedia}
        />
      )}

      <button onClick={capturePhoto}>Capture</button>
      <button onClick={()=>props.handleCloseSefliePopup()}>Cancel</button>
     
    </>
  );
};

export default Camera;
